export default "__VITE_ASSET__cLZvjpXE__"